// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.add-module-container {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  padding: 10px;
  background-color: #f8f9fa;
  border: 2px dashed #007bff;
  border-radius: 8px;
  cursor: pointer;
  transition: 0.3s ease;
}

.add-module-container:hover {
  background-color: #e2e6ea;
  border-color: #0056b3;
}

.add-module-container .icon {
  font-size: 24px;
  color: #007bff;
  margin-right: 8px;
}

.add-module-container span {
  font-size: 16px;
  font-weight: 500;
  color: #007bff;
}

.modal-custom .modal-content {
  border-radius: 18px;
  padding: 22px;
  background: #ffffff;
  box-shadow: 0px 12px 30px rgba(0, 0, 0, 0.2);
}

.modal-custom .modal-header {
  background-color: #007bff;
  color: white;
  border-bottom: none;
  text-align: center;
  padding: 15px;
  border-radius: 10px 10px 0 0;
}

.modal-custom .modal-title {
  font-weight: bold;
  font-size: 1.6rem;
}

.modal-custom .modal-body {
  background-color: #f8f9fa;
  padding: 22px;
  border-radius: 10px;
}

/* -------- Inputs -------- */
.input-field {
  border-radius: 8px;
  padding: 12px;
  border: 1px solid #ced4da;
  transition: all 0.3s ease-in-out;
}

.input-field:focus {
  border-color: #007bff;
  box-shadow: 0px 0px 10px rgba(0, 123, 255, 0.4);
  outline: none;
}

/* -------- Boutons -------- */
.button-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.btn-next,
.btn-prev {
  padding: 12px 18px;
  border-radius: 8px;
  font-weight: 600;
  transition: all 0.3s ease-in-out;
}

.btn-next {
  background-color: #007bff;
  border: none;
  color: #ffffff;
}

.btn-next:hover {
  background-color: #0056b3;
}

.btn-prev {
  background-color: #6c757d;
  border: none;
  color: #ffffff;
  margin-right: 10px;
}

.btn-prev:hover {
  background-color: #5a6268;
}

.modal-custom .form-check {
  background: white;
  padding: 12px;
  border-radius: 6px;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.1);
  margin-bottom: 12px;
}

.modal-custom .form-check label {
  font-weight: 500;
}

.modal-custom .btn-submit {
  background-color: #28a745;
  padding: 12px 22px;
  font-weight: bold;
  border-radius: 6px;
  transition: background 0.3s ease-in-out, transform 0.2s ease;
}

.modal-custom .btn-submit:hover {
  background-color: #218838;
  transform: scale(1.05);
}

.modal-custom .btn {
  border-radius: 6px;
  padding: 12px 22px;
  font-weight: 500;
}

.modules-container {
  max-height: 300px; /* Définissez la hauteur maximale souhaitée */
  overflow-y: auto; /* Ajoutez le défilement vertical */
  padding: 10px; /* Ajoutez un peu de padding pour l'espacement */
  border-radius: 8px; /* Ajoutez des coins arrondis */
  background-color: #f8f9fa; /* Ajoutez une couleur de fond */
}
.tooltip-container {
  position: relative;
  display: inline-block;
}

.tooltip-text {
  visibility: hidden;
  width: 200px;
  background-color: #555;
  color: #fff;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;
  position: absolute;
  z-index: 1;
  bottom: 125%; /* Positionner le tooltip au-dessus de l'élément */
  left: 50%;
  margin-left: -100px;
  opacity: 0;
  transition: opacity 0.3s;
}

.tooltip-container:hover .tooltip-text {
  visibility: visible;
  opacity: 1;
}

.modules-container {
  max-height: 300px;
  overflow-y: auto;
  padding: 10px;
  background-color: #f8f9fa;
}

.modules-container .form-group {
  width: 100%;
  margin-bottom: 10px;
}
`, "",{"version":3,"sources":["webpack://./src/Components/ModuleCreator/AddModulePopup.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,+CAA+C;EAC/C,aAAa;AACf;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;;EAEE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,4DAA4D;AAC9D;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB,EAAE,6CAA6C;EAChE,gBAAgB,EAAE,mCAAmC;EACrD,aAAa,EAAE,gDAAgD;EAC/D,kBAAkB,EAAE,+BAA+B;EACnD,yBAAyB,EAAE,gCAAgC;AAC7D;AACA;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,sBAAsB;EACtB,WAAW;EACX,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,YAAY,EAAE,kDAAkD;EAChE,SAAS;EACT,mBAAmB;EACnB,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB","sourcesContent":[".add-module-container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 20px;\n  padding: 10px;\n  background-color: #f8f9fa;\n  border: 2px dashed #007bff;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: 0.3s ease;\n}\n\n.add-module-container:hover {\n  background-color: #e2e6ea;\n  border-color: #0056b3;\n}\n\n.add-module-container .icon {\n  font-size: 24px;\n  color: #007bff;\n  margin-right: 8px;\n}\n\n.add-module-container span {\n  font-size: 16px;\n  font-weight: 500;\n  color: #007bff;\n}\n\n.modal-custom .modal-content {\n  border-radius: 18px;\n  padding: 22px;\n  background: #ffffff;\n  box-shadow: 0px 12px 30px rgba(0, 0, 0, 0.2);\n}\n\n.modal-custom .modal-header {\n  background-color: #007bff;\n  color: white;\n  border-bottom: none;\n  text-align: center;\n  padding: 15px;\n  border-radius: 10px 10px 0 0;\n}\n\n.modal-custom .modal-title {\n  font-weight: bold;\n  font-size: 1.6rem;\n}\n\n.modal-custom .modal-body {\n  background-color: #f8f9fa;\n  padding: 22px;\n  border-radius: 10px;\n}\n\n/* -------- Inputs -------- */\n.input-field {\n  border-radius: 8px;\n  padding: 12px;\n  border: 1px solid #ced4da;\n  transition: all 0.3s ease-in-out;\n}\n\n.input-field:focus {\n  border-color: #007bff;\n  box-shadow: 0px 0px 10px rgba(0, 123, 255, 0.4);\n  outline: none;\n}\n\n/* -------- Boutons -------- */\n.button-container {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 20px;\n}\n\n.btn-next,\n.btn-prev {\n  padding: 12px 18px;\n  border-radius: 8px;\n  font-weight: 600;\n  transition: all 0.3s ease-in-out;\n}\n\n.btn-next {\n  background-color: #007bff;\n  border: none;\n  color: #ffffff;\n}\n\n.btn-next:hover {\n  background-color: #0056b3;\n}\n\n.btn-prev {\n  background-color: #6c757d;\n  border: none;\n  color: #ffffff;\n  margin-right: 10px;\n}\n\n.btn-prev:hover {\n  background-color: #5a6268;\n}\n\n.modal-custom .form-check {\n  background: white;\n  padding: 12px;\n  border-radius: 6px;\n  box-shadow: 0 0 12px rgba(0, 0, 0, 0.1);\n  margin-bottom: 12px;\n}\n\n.modal-custom .form-check label {\n  font-weight: 500;\n}\n\n.modal-custom .btn-submit {\n  background-color: #28a745;\n  padding: 12px 22px;\n  font-weight: bold;\n  border-radius: 6px;\n  transition: background 0.3s ease-in-out, transform 0.2s ease;\n}\n\n.modal-custom .btn-submit:hover {\n  background-color: #218838;\n  transform: scale(1.05);\n}\n\n.modal-custom .btn {\n  border-radius: 6px;\n  padding: 12px 22px;\n  font-weight: 500;\n}\n\n.modules-container {\n  max-height: 300px; /* Définissez la hauteur maximale souhaitée */\n  overflow-y: auto; /* Ajoutez le défilement vertical */\n  padding: 10px; /* Ajoutez un peu de padding pour l'espacement */\n  border-radius: 8px; /* Ajoutez des coins arrondis */\n  background-color: #f8f9fa; /* Ajoutez une couleur de fond */\n}\n.tooltip-container {\n  position: relative;\n  display: inline-block;\n}\n\n.tooltip-text {\n  visibility: hidden;\n  width: 200px;\n  background-color: #555;\n  color: #fff;\n  text-align: center;\n  border-radius: 6px;\n  padding: 5px 0;\n  position: absolute;\n  z-index: 1;\n  bottom: 125%; /* Positionner le tooltip au-dessus de l'élément */\n  left: 50%;\n  margin-left: -100px;\n  opacity: 0;\n  transition: opacity 0.3s;\n}\n\n.tooltip-container:hover .tooltip-text {\n  visibility: visible;\n  opacity: 1;\n}\n\n.modules-container {\n  max-height: 300px;\n  overflow-y: auto;\n  padding: 10px;\n  background-color: #f8f9fa;\n}\n\n.modules-container .form-group {\n  width: 100%;\n  margin-bottom: 10px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
